import React, { Component } from 'react';
import { Badge, CardBody, CardFooter, Button, CardHeader, Col, Collapse, Fade, Row } from 'reactstrap';
import axios from "axios";
import {appConfig} from "./../tools/AppConfig";
import Waiting from './../modules/waiting';
import Form from 'react-validation/build/form';
import VButton from 'react-validation/build/button';
import Input from 'react-validation/build/input';
import Message from './errors/message';
import SimpleHeader from './../modules/simpleHeader_new';
import Card from './../modules/paymentMethods/card';
import Installments from '../modules/paymentMethods/installments';
import Wallet from './../modules/paymentMethods/wallet';
import Cash from './../modules/paymentMethods/cash';
import Aman from './../modules/paymentMethods/aman';
import Premium from './../modules/paymentMethods/premium';
import Valu from './../modules/paymentMethods/valu';
import Sympl from './../modules/paymentMethods/sympl';
import Jawwal from './../modules/paymentMethods/Jawwal';
import Delivery from './../modules/paymentMethods/delivery_new';
import SubData from './../modules/paymentMethods/sub-data_new';

import amanImg from './../../statics/img/payment_methods_logos/logo_aman.png';
import masaryImg from './../../statics/img/payment_methods_logos/logo_masary.png';
import cashImg from './../../statics/img/newPayment/cash.svg';
import cardImg from './../../statics/img/newPayment/credit.svg';
import walletImg from './../../statics/img/newPayment/wallet.svg';
import kioskImg from './../../statics/img/newPayment/kiosk.svg';
import premiumImg from './../../statics/img/payment_methods_logos/logo_premium.gif';
import valuImg from './../../statics/img/payment_methods_logos/ValU.png';
import symplImg from './../../statics/img/payment_methods_logos/Sympl.png';
import favicon from './../../statics/img/favicon.svg';
import favicon_jawwal from './../../statics/img/fav_icon.png';

//import './../custom.css';
import './../custom_new.css';
import './invoice.css';

import 'icheck/skins/all.css'; // or single skin css
import {Radio, RadioGroup} from 'react-icheck';
import validator from 'validator';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is require.</div>;
  }
};
const quantityRule = (value) => {
    //isDecimal(str [, options])
    //isInt(str [, options])
    // 
    if (!validator.isInt(value.toString(), {min: 1, max: 100}) ) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid integer between 1 and 100</div>;
    }
};

class product extends Component {
    constructor(props){
        super(props);
        this.state = {
            dataLoaded: false,
            userData: null,
            requestComplete: false,
            completeMessage: {'head': "", 'body': ""},
            quantity: 1,
            total: null,
            quantityFormComplete: true,
            currentMethod: '',
            MethodsName: {
                VPC: "Card",
                UIG: "Wallet",
                CASH: "Cash Collection",
                CAGG: "Accept Kiosk",
                PREMIUM: "Premium",
                VALU: "Valu",
                SYMPL: "Sympl",
                MPAY: "Jawwal Pay",
                installments: "Installments"
            },
            paymentMethodsDisable: false,
            deliveryDataCollected: false,
            deliveryData: {

            },
            //acq_partner
            acq_partner: false,
            styleData: {},
            accordion: [true, false, false, false, false],
        };
        this.renderError  = this.renderError.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.paymentsMethods = this.paymentsMethods.bind(this);
        this.renderCurrentImg = this.renderCurrentImg.bind(this);
        this.disableAllPaymentMethods = this.disableAllPaymentMethods.bind(this);
        this.enableAllPaymentMethods = this.enableAllPaymentMethods.bind(this);
        this.handleMethodChange = this.handleMethodChange.bind(this);
        this.renderPaymentMethod = this.renderPaymentMethod.bind(this);
        this.currentPaymentMethodComponent = this.currentPaymentMethodComponent.bind(this);
        this.setDeliveryData = this.setDeliveryData.bind(this);
        this.setSubDeliveryData = this.setSubDeliveryData.bind(this);
        this.setReqComplete = this.setReqComplete.bind(this);
        this.handelQuantityChange = this.handelQuantityChange.bind(this);
        this.setPartnerColors = this.setPartnerColors.bind(this);
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.renderDeliveryForm = this.renderDeliveryForm.bind(this);
        this.renderSubDeliveryForm = this.renderSubDeliveryForm.bind(this);
        this.loadData();
    }
    toggleAccordion(tab) {
        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => tab === index ?  !x : false);
        this.setState({
          accordion: state,
        });
    }
    renderDeliveryForm() {
        return <Delivery collapseButton={true} toggleAccordion={this.toggleAccordion} sourcePage='product' userData={this.state.userData} setDeliveryData={this.setDeliveryData} currentDeliveryData={this.state.deliveryData}/>
    }
    renderSubDeliveryForm() {
        return <SubData collapseButton={true} toggleAccordion={this.toggleAccordion} userData={this.state.userData} setSubDeliveryData={this.setSubDeliveryData}/>
    }
    loadData(){
        let token = this.props.token;
        let productUrl = appConfig.getServerUrl() + '/product2/' + token;
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.get(
            productUrl,
            config
        )
        .then((respond)=>{
            if(respond.data.error){
                this.setReqComplete({head: '', body: respond.data.error});
            }else{
                this.setState({userData: respond.data, dataLoaded: true, total: respond.data.amount, quantityFormComplete: true, paymentMethodsDisable: false},()=>{
                    
                    let current_integrations_keys = [];
                    let all_integ_key_arr = Object.keys(this.state.userData.integrations);
                    for(let i=0; i< all_integ_key_arr.length;i++){
                        if(this.state.MethodsName[all_integ_key_arr[i]]){
                            current_integrations_keys.push(all_integ_key_arr[i]);
                        }
                    }
                    // this.setState({currentMethod: current_integrations_keys[0]},()=>{
                    this.setState({},()=>{
                        if(this.state.acq_partner){
                            this.setPartnerColors(this.state.styleData)
                        }else{
                            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                            link.rel="shortcut icon"
                            link.type = 'image/x-icon'
                            link.href= favicon;
                        }
                    })
                });
            }
        })
        .catch((err)=>{
            if(this.state.acq_partner){
                this.setPartnerColors(this.state.styleData)
            }else{
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.rel="shortcut icon"
                link.type = 'image/x-icon'
                link.href= favicon;
            }
            this.setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
        });
    }
    setPartnerColors(data){
        setTimeout(()=>{
            document.querySelectorAll(".acq_partner").forEach(el => el.style.background = data.partner_css.header_background);
            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.rel="shortcut icon"
            link.type = 'image/x-icon'
            link.href= favicon_jawwal;
        },100)
    }
    paymentsMethods(){
        let current_integrations_keys = [];
        let all_integ_key_arr = Object.keys(this.state.userData.integrations);
        for(let i=0; i< all_integ_key_arr.length;i++){
            if(this.state.MethodsName[all_integ_key_arr[i]]){
                current_integrations_keys.push(all_integ_key_arr[i]);
            }
        }
        if(this.state.userData.bank_installment && this.state.userData.bank_installment !== null){
            current_integrations_keys.push('installments');
        }
        return(
            // <RadioGroup name="radio" defaultValue={current_integrations_keys[0]} onChange = {this.handleMethodChange}>
            <RadioGroup name="radio" onChange = {this.handleMethodChange}>
                {current_integrations_keys.map((key, index) => {
                    return <Radio
                        key= {key}
                        value={key}
                        radioClass="iradio_flat-blue"
                        increaseArea="20%"                                
                        label={"<span class='paymentMethodSpan'>" + this.renderCurrentImg(key) + "<span>" + this.state.MethodsName[key] + "</span></span>"}
                        disabled={this.state.paymentMethodsDisable}
                    />
                })}
            </RadioGroup>
        );
    }
    renderCurrentImg(key){
        let allowedAggre = this.state.userData.allowed_aggregators;
        if(key === 'VPC' || key === 'installments'){
            return "<img class='paymentMethodImg' src=" + cardImg + " alt=" + key + " />"
        }else if(key === 'UIG'){
            return "<img class='paymentMethodImg' src=" + walletImg + " alt=" + key + " />"
        }else if(key === 'CASH'){
            return "<img class='paymentMethodImg' src=" + cashImg + " alt=" + key + " />"
        }else if(key === 'CAGG'){
            if(allowedAggre === "aman"){
                return "<img class='paymentMethodImg' src=" + amanImg + " alt=" + key + " />"
            }else if(allowedAggre === "masary"){
                return "<img class='paymentMethodImg' src=" + masaryImg + " alt=" + key + " />"
            }else if(allowedAggre === "aman/masary"){
                return "<img class='paymentMethodImg' src=" + amanImg + " alt=" + key + " /><img class='paymentMethodImg' src=" + masaryImg + " alt=" + key + " />"
            }else{
                return ''
            }
        }else if(key === 'PREMIUM'){
            return "<img class='paymentMethodImg' src=" + premiumImg + " alt=" + key + " />"
        }else if(key === 'VALU'){
            return "<img class='paymentMethodImg' src=" + valuImg + " alt=" + key + " />"
        }else if(key === 'SYMPL'){
            return "<img class='paymentMethodImg' src=" + symplImg + " alt=" + key + " />"
        }
        return ''
    }
    disableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: true});
    }
    enableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: false});
    }
    handleMethodChange(e){
        this.setState({currentMethod: e.target.value});
    }
    handelQuantityChange(icon){
        let maxValue = 1;
        if(this.state.userData && this.state.userData.product && this.state.userData.product.inventory){
            maxValue = this.state.userData.product.inventory;
        }
        let oldQuantity = this.state.quantity;
        if(icon === "+" && oldQuantity < maxValue){
            let newTotal = (oldQuantity + 1) * this.state.userData.amount;
            this.setState({quantity: (oldQuantity + 1), total: newTotal});
        }else if(icon === "-" && oldQuantity > 1){
            let newTotal = (oldQuantity - 1) * this.state.userData.amount;
            this.setState({quantity: (oldQuantity - 1), total: newTotal});
        }
    }
    renderPaymentMethod() {
        let deliveryNeed = this.state.userData.product.delivery_needed;
        if(deliveryNeed === false){
            if(this.state.deliveryDataCollected){
                return this.currentPaymentMethodComponent();
            }else{
                return <SubData collapseButton={true} toggleAccordion={this.toggleAccordion} userData={this.state.userData} setSubDeliveryData={this.setSubDeliveryData}/>
            }
            //return this.currentPaymentMethodComponent();SubData
        }else if (deliveryNeed === true){
            if(this.state.deliveryDataCollected){
                return this.currentPaymentMethodComponent();
            }else{
                return <Delivery sourcePage='product' userData={this.state.userData} setDeliveryData={this.setDeliveryData} currentDeliveryData={this.state.deliveryData}/>
            }
        }
        
    }
    setDeliveryData(data) {
        this.setState({deliveryDataCollected: true, deliveryData: {...data}}, () => {
            if (!this.state.accordion[1]) {
                this.toggleAccordion(1)
            }
        });
    }
    setSubDeliveryData(data) {
        this.setState({deliveryDataCollected: true, deliveryData: {...data}}, () => {
            this.toggleAccordion(1)
        });
    }
    setReqComplete(Message){
        this.setState({requestComplete: true, completeMessage: Message, dataLoaded: true});
    }
    currentPaymentMethodComponent() {
        let currentMethod = this.state.currentMethod;
        let deliveryNeed = this.state.userData.product.delivery_needed;
        if( currentMethod === 'VPC'){
            if(deliveryNeed === false){
                return <Card
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Card 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'UIG'){
            if(deliveryNeed === false){
                return <Wallet  
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete}/>
            }else if (deliveryNeed === true){
                return <Wallet  
                    sourcePage='product' 
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CASH'){
            if(this.state.deliveryDataCollected){
                if(this.state.deliveryData.city){
                    return <Cash 
                        sourcePage='product'
                        quantity={this.state.quantity}
                        deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} 
                    />
                }else{
                    return <Delivery sourcePage='product' userData={this.state.userData} setDeliveryData={this.setDeliveryData} currentDeliveryData={this.state.deliveryData}/>
                }                
            }else{
                return <Delivery sourcePage='product' userData={this.state.userData} setDeliveryData={this.setDeliveryData} currentDeliveryData={this.state.deliveryData}/>
            }
            if(deliveryNeed === false){
                return <Wallet 
                    sourcePage='product' 
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Wallet 
                    sourcePage='product' 
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CAGG'){
            if(deliveryNeed === false){
                return <Aman 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Aman 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'PREMIUM'){
            if(deliveryNeed === false){
                return <Premium 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Premium 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'VALU'){
            if(deliveryNeed === false){
                return <Valu 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Valu 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'SYMPL'){
            if(deliveryNeed === false){
                return <Sympl 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Sympl 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'MPAY'){
            if(deliveryNeed === false){
                return <Jawwal sourcePage='product' 
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Jawwal sourcePage='product' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if(currentMethod === 'installments'){
            if(deliveryNeed === false){
                return <Installments
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Installments 
                    sourcePage='product'
                    quantity={this.state.quantity}
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else{
            return <p>{this.state.MethodsName[this.state.currentMethod]}</p>
        }
    }
    renderError(){
        return ( 
            <div className="invoice">
                <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                <Message body={this.state.userData.errorMessage} />
            </div>
        );
    }
    renderBody(){
        let domain = window.location.hostname;
        let lang = localStorage.lang !== undefined ? localStorage.lang : "en";
        if(domain === "localhost"){
            domain = "acceptstagingtest.paymobsolutions.com"
        } else {
            domain = "accept.paymob.com"
        }
        let regURL = "https://" + domain + "/portal2/"+ lang +"/register";
        //<h1>invoice {this.props.match.params.id} page</h1>
        if(this.state.requestComplete){
            return ( 
                <div class="newStandalone">
                    <div className="invoice">
                        <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                        <div className="companyDetails">
                            <div className="compLogo">
                                {this.state.userData && this.state.userData.logo_uri&&
                                    <img src={appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                                }
                            </div>
                        </div>
                        <div className="standaloneBody">
                            <Message head={this.state.completeMessage.head} body={this.state.completeMessage.body} sympl={this.state.completeMessage.sympl} sympl_data={this.state.completeMessage.sympl_data} />
                        </div>
                        <div className="startSell">
                                <p>Start selling your products</p>
                                <a href={regURL} target="_blank">Get Started<i className="fa fa-arrow-right"></i></a>
                            </div>
                    </div>
                </div>
            );
        }else{
            return (
                <div class="newStandalone">
                    <div className="invoice">
                        <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                        <div className="companyDetails">
                            <div className="compLogo">
                                <img src={appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                            </div>
                            <p> {this.state.userData.merchant_name}</p>
                        </div>
                        <div className="orderDetails">
                            <div className="orderImgDesc">
                                {this.state.userData.product_image_uri && 
                                    <div className="orderImg">
                                        <img src={appConfig.getServerUrl() + this.state.userData.product_image_uri}/>
                                    </div>
                                }
                                <div className="orderNameDesc">
                                    <p className="productName">{this.state.userData.product.product_name}</p>
                                    <p className="productDesc">{this.state.userData.product.product_description && this.state.userData.product.product_description}</p>
                                    {this.state.userData.product.allow_quantity_edit &&
                                        <div className="priceItem">
                                            <span>
                                                <button disabled={!this.state.userData.product.allow_quantity_edit} onClick={() => {this.handelQuantityChange("-")}} className="quantityChangeBtn left">-</button>
                                                <input type="number" className="quantityInput" placeholder="Enter the number of items"
                                                    value={this.state.quantity}
                                                    // onChange={this.handelQuantityChange}
                                                    // validations={[required, quantityRule]}
                                                    disabled={true}
                                                />
                                                <button disabled={!this.state.userData.product.allow_quantity_edit} onClick={() => {this.handelQuantityChange("+")}} className="quantityChangeBtn right">+</button>
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="orderPrice">
                                <div className="priceItem">
                                    <p>
                                    Item Price
                                    </p>
                                    <span>
                                        {(this.state.userData.amount) + ' ' + this.state.userData.currency}
                                    </span>
                                </div>
                                <div className="priceItem">
                                    <p>
                                    Quantity
                                    </p>
                                    <span>
                                        {this.state.quantity}
                                    </span>
                                </div>
                                <div className="priceItem lastItem">
                                    <p>
                                    Total Payment
                                    </p>
                                    <span>
                                    {(this.state.total ) + ' ' + this.state.userData.currency}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="standaloneBody">
                            {this.state.userData.product.delivery_needed?
                                <div>
                                    <CardHeader id="headingOne">
                                    <Button  className="collapseHeader" aria-expanded={this.state.accordion[0]} aria-controls="collapseOne" onClick={()=>this.toggleAccordion(0)}>
                                        <h5 className="">Personal Details</h5>
                                    </Button>
                                    </CardHeader>
                                    <Collapse isOpen={this.state.accordion[0]} data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne">
                                    <CardBody>
                                        {this.renderDeliveryForm()}
                                    </CardBody>
                                    </Collapse>
                                </div>
                            :
                                <div>
                                    <CardHeader id="headingOne">
                                    <Button  className="collapseHeader" aria-expanded={this.state.accordion[0]} aria-controls="collapseOne" onClick={()=>this.toggleAccordion(0)}>
                                        <h5 className="">Personal Details</h5>
                                    </Button>
                                    </CardHeader>
                                    <Collapse isOpen={this.state.accordion[0]} data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne">
                                    <CardBody>
                                        {this.renderSubDeliveryForm()}
                                    </CardBody>
                                    </Collapse>
                                </div>
                            }
                            <div>
                                <CardHeader id="headingTwo">
                                    <Button  className="collapseHeader"  aria-expanded={this.state.accordion[1]} aria-controls="collapseTwo" onClick={this.toggleAccordion}>
                                        <h5 className="">Payment Method</h5>
                                    </Button>
                                </CardHeader>
                                <Collapse isOpen={this.state.accordion[1]} data-parent="#accordion" id="collapseTwo">
                                    <CardBody>
                                        <div className="paymentsMethodsNew">
                                            <div className="methods">
                                                <div id="choose_payment">
                                                    <h3>Choose your payment method</h3>
                                                    {this.paymentsMethods()}
                                                </div>
                                            </div>
                                            <div  id="payDiv">
                                                {this.state.accordion[1] && this.currentPaymentMethodComponent()}                            
                                            </div>  
                                        </div>
                                    </CardBody>
                                </Collapse>
                            </div>

                            <div className="startSell">
                                <p>Start selling your products</p>
                                <a href={'https://acceptstagingtest.paymobsolutions.com/portal2/#/login'} >Get Started<i className="fa fa-arrow-right"></i></a>
                            </div>
                        </div>
                        {/* <div className="right_col" role="main" id="content">
                            <div className="row" id="orderDetails">
                                <div className="col-md-5 col-md-offset-1 col-sm-6 col-xs-12">
        
                                    <div className="x_panel errorTokenHide">
                                        <div className="x_title orderTitle">
                                            <h2 className="merchN">{this.state.userData.merchant_name}</h2>
                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="x_content">
                                        <div className="caption">
                                                <div className="row">
                                                    <div className="col-md-4 col-xs-5">
                                                        <h4 className="black">Price:</h4>
                                                    </div>
                                                    <div className="col-md-7 col-xs-7 price">
                                                        <h4><label value="">{(this.state.userData.amount) + ' ' + this.state.userData.currency}</label></h4>
                                                    </div>
                                                </div>
                                                <Form onSubmit={this.handleQuantitySubmit} id='productFormId'>
                                                    <div className="row">
                                                        <div className="col-md-4 col-xs-5">
                                                            <h4 className="black">Quantity:</h4>
                                                        </div>
                                                        <div className="form-group col-md-6 col-sm-4 col-xs-4">
                                                            <Input type="number" className="form-control" placeholder="Enter the number of items"
                                                                value={this.state.quantity}
                                                                onChange={this.handelQuantityChange}
                                                                validations={[required, quantityRule]}
                                                                disabled={this.state.quantityFormComplete}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 col-xs-5">
                                                            <h4 className="black">Total: </h4>
                                                        </div>
                                                        <div className="col-md-7 col-xs-7 price">
                                                            <h4><label>{(this.state.total ) + ' ' + this.state.userData.currency}</label></h4>
                                                        </div>
                                                    </div>
                                                    <div className="row text-center">
                                                        {this.state.quantityFormComplete?
                                                            null
                                                        :
                                                            <VButton className="btn btn-primary active">Confirm Quantity</VButton>
                                                        }
                                                    </div>
                                                </Form>
                                            </div>
                                            {!this.state.paymentMethodsDisable?
                                                <div>
                                                    <hr/>
                                                    <div id="choose_payment">
                                                        <h3>Choose Payment Method</h3>
                                                        <br/>
                                                        {this.paymentsMethods()}
                                                        
                                                    </div>
                                                </div>
                                            :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 col-md-offset-1 col-sm-6 col-xs-12" id="payDiv">
                                    {this.state.quantityFormComplete ? this.renderPaymentMethod(): null}                            
                                </div>
                            </div>
                        </div> */}
        
                    </div> 
                </div>
            );
        }
    }
    render(){
        return (
            <div>
                {this.state.dataLoaded?this.renderBody():<Waiting height='100vh' />}
            </div>
        );
    }
    
}

export default product;
